import hcOffcanvasNav from 'hc-offcanvas-nav';

export class MobileNav {

    async init() {
        console.log('mmenu');
        // jQuery(document).ready(function() {
 
        //     var hamburger = jQuery('.quarta-menu-toggle'),
        //         menu      = jQuery('.handheld-navigation');
        //         //sub_menu  = jQuery('.sub-menu-wrapper'),
        //         //menu_item = jQuery('.has-sub-menu');
        //       hamburger.on('click', function() {
        //           menu.slideToggle('slow');
        //          // menu.removeClass('handheld-navigation-hidden');
        //           jQuery(this).toggleClass('active');
        //       });
            
        //     //   menu_item.on('click', function() {
        //     //       jQuery(this).children('.sub-menu-wrapper').slideToggle();
        //     //   });
              
        //     });
        document.addEventListener('DOMContentLoaded', function() {

            var Nav = new hcOffcanvasNav('.handheld-navigation', {
              disableAt: 1024,
              customToggle: '.quarta-menu-toggle',
              position: 'top',
              levelTitles: true,
              levelTitleAsBack: true,
              labelClose: 'Close'
            });
          
          });
    }

}